module.exports = __webpack_public_path__ + "static/media/bmw_loc-ind_arrow-down.abbeb703.svg";